import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export function UrgencyBar() {
  return <div className="bg-brand-navy py-5 px-4 text-center border-y-4 border-brand-orange" data-id="element-269">
      <p className="font-display font-bold text-brand-orange text-base md:text-2xl uppercase tracking-wide mb-3 animate-pulse" data-id="element-270">
        ⏰ El Precio de Lanzamiento Termina En:
      </p>
      <CountdownTimer data-id="element-271" />
      <p className="text-xs md:text-sm text-white/80 font-bold uppercase tracking-widest mt-3" data-id="element-272">
        Después sube el precio y los bonos no estarán incluidos
      </p>
    </div>;
}